import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { SetupAppService } from '@fry/upgrade/route.service';

/**
 * Guard that handles app setup
 * @returns A promise that resolves when setup is complete
 */
export const setupGuard: CanActivateFn = async (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
) => {
  const setupApp: any = inject(SetupAppService);
  const router = inject(Router);
  try {
    await setupApp.setupApp();
    return true;
  } catch (err: any) {
    if (err && err.status === 477) {
      return router.createUrlTree(['/org-chooser']);
    }
    throw err; // Re-throw other errors
  }
};
